module.exports = __webpack_public_path__ + "img/b2.48c47232.png";